import GeneralContainerView from "./GeneralContainerView";
export default GeneralContainerView;
